export const blogPosts = [
  {
    id: 1,
    title: "Understanding React Hooks",
    excerpt:
      "React Hooks let you use state and other React features without writing a class...",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2k9R51R1Lj6NgwdDO3p32fzdtE4-z5hXZBw&s",
    category: "React",
    date: "Jan 20, 2026",
    link: "/blog/react-hooks",
  },
  {
    id: 2,
    title: "JavaScript ES2026 Features",
    excerpt:
      "ES2026 introduces some exciting new features for JavaScript developers...",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2k9R51R1Lj6NgwdDO3p32fzdtE4-z5hXZBw&s",
    category: "JavaScript",
    date: "Jan 18, 2026",
    link: "/blog/es2026",
  },
  {
    id: 3,
    title: "Building Responsive UI with MUI",
    excerpt:
      "Learn how to build beautiful and responsive user interfaces using Material UI...",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2k9R51R1Lj6NgwdDO3p32fzdtE4-z5hXZBw&s",
    category: "UI Design",
    date: "Jan 15, 2026",
    link: "/blog/mui-responsive",
  },
  {
    id: 1,
    title: "Understanding React Hooks",
    excerpt:
      "React Hooks let you use state and other React features without writing a class...",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2k9R51R1Lj6NgwdDO3p32fzdtE4-z5hXZBw&s",
    category: "React",
    date: "Jan 20, 2026",
    link: "/blog/react-hooks",
  },
  {
    id: 2,
    title: "JavaScript ES2026 Features",
    excerpt:
      "ES2026 introduces some exciting new features for JavaScript developers...",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2k9R51R1Lj6NgwdDO3p32fzdtE4-z5hXZBw&s",
    category: "JavaScript",
    date: "Jan 18, 2026",
    link: "/blog/es2026",
  },
  {
    id: 3,
    title: "Building Responsive UI with MUI",
    excerpt:
      "Learn how to build beautiful and responsive user interfaces using Material UI...",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2k9R51R1Lj6NgwdDO3p32fzdtE4-z5hXZBw&s",
    category: "UI Design",
    date: "Jan 15, 2026",
    link: "/blog/mui-responsive",
  },
  {
    id: 1,
    title: "Understanding React Hooks",
    excerpt:
      "React Hooks let you use state and other React features without writing a class...",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2k9R51R1Lj6NgwdDO3p32fzdtE4-z5hXZBw&s",
    category: "React",
    date: "Jan 20, 2026",
    link: "/blog/react-hooks",
  },
  {
    id: 2,
    title: "JavaScript ES2026 Features",
    excerpt:
      "ES2026 introduces some exciting new features for JavaScript developers...",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2k9R51R1Lj6NgwdDO3p32fzdtE4-z5hXZBw&s",
    category: "JavaScript",
    date: "Jan 18, 2026",
    link: "/blog/es2026",
  },
  {
    id: 3,
    title: "Building Responsive UI with MUI",
    excerpt:
      "Learn how to build beautiful and responsive user interfaces using Material UI...",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2k9R51R1Lj6NgwdDO3p32fzdtE4-z5hXZBw&s",
    category: "UI Design",
    date: "Jan 15, 2026",
    link: "/blog/mui-responsive",
  },
];
